import React, { Dispatch, SetStateAction, useContext, useState } from 'react'
import { TitleLine } from '../../../../components/TitleLine'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { ContextResidents } from '../../../../context/context_residents'
import {
  AddressContainer,
  ButtonContainer,
  ButtonRow,
  Container,
  Divider,
  Row,
  Section,
  Title,
} from './styles'

interface FormResidentInactiveProps {
  handleModalEnable: Dispatch<SetStateAction<boolean>>
}

export const FormResidentInactive = ({
  handleModalEnable,
}: FormResidentInactiveProps) => {
  const { editItem, updateItem } = useContext(ContextResidents)
  const [inactiveUser, setInactiveUser] = useState(editItem)

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setInactiveUser((prev) => ({
      ...prev,
      active: true,
    }))
    setInactiveUser((updatedList) => {
      updateItem(updatedList)
      return updatedList
    })
    toggleFunction(handleModalEnable)
  }

  return (
    <Container onSubmit={handleSubmit}>
      <Section>
        <TitleLine title="Dados do titular" />
        <Input.Root>
          <Input.Label title="Nome do usuário" htmlFor="residentName" />
          <Input.Wrapper>
            <Input.Content
              id="residentName"
              type="text"
              value={editItem.name}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="E-mail" htmlFor="residentEmail" />
          <Input.Wrapper>
            <Input.Content
              id="residentEmail"
              type="text"
              value={editItem.email}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Telefone" htmlFor="residentPhone" />
          <Input.Wrapper>
            <Input.Content
              id="residentPhone"
              type="tel"
              mask="telNumber"
              value={editItem.phone}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
      </Section>
      <Divider />
      <Section>
        <Title>Dados de residência</Title>
        <Select
          onchange={() => console.log('change')}
          label={{
            title: 'Contrato de seguro',
            htmlFor: '',
            color: '#CECECE',
            fontSize: '12px',
          }}
          // data={''}
          backgroundcolor=""
          bordercolor="#CECECE"
          data={[editItem.Contract]}
          currentOption={editItem.Contract.id}
          outlinecolor=""
          disabled
        />
        {editItem?.Address.length > 0
          ? editItem?.Address.map((item, idx) => {
              return (
                <AddressContainer key={'Address' + idx}>
                  <TitleLine title={'Endereço ' + (idx + 1)} />
                  <Input.Root>
                    <Input.Label
                      title="Endereço"
                      htmlFor={'residentAddress' + idx}
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id={'residentAddress' + idx}
                        type="text"
                        name="address"
                        value={item.address}
                        readOnly
                      />
                    </Input.Wrapper>
                  </Input.Root>
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label title="CEP" htmlFor={'residentCEP' + idx} />
                      <Input.Wrapper>
                        <Input.Content
                          id={'residentCEP' + idx}
                          type="text"
                          value={item.zipcode}
                          name="zipcode"
                          mask="cep"
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="2">
                      <Input.Label
                        title="Bairro"
                        htmlFor={'residentDistrict' + idx}
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id={'residentDistrict' + idx}
                          type="text"
                          name="burgh"
                          value={item.burgh}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                  <Row>
                    <Input.Root flex="2">
                      <Input.Label
                        title="Cidade"
                        htmlFor={'residentCity' + idx}
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id={'residentCity' + idx}
                          type="text"
                          name="city"
                          value={item.city}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Select
                      onchange={() => console.log('')}
                      flex="1"
                      disabled
                      name={'state'}
                      label={{
                        title: 'Estado',
                        htmlFor: '',
                        color: '',
                        fontSize: '12px',
                      }}
                      data={[{ id: 'SP', value: 'São Paulo' }]}
                      backgroundcolor=""
                      bordercolor="#CECECE"
                      currentOption={item.state}
                      outlinecolor=""
                    />
                  </Row>
                  <Select
                    onchange={() => console.log('')}
                    disabled
                    name={'id_responsible_base'}
                    label={{
                      title: 'Base responsável',
                      htmlFor: '',
                      color: '',
                      fontSize: '12px',
                    }}
                    data={[]}
                    backgroundcolor=""
                    bordercolor=""
                    currentOption={item.id_responsible_base}
                    outlinecolor=""
                  />
                  {/* <Input.Root>
                <Input.Label
                  title="Posto responsável"
                  htmlFor="residentResponsiblePost"
                />
                <Input.Wrapper>
                  <Input.Content
                    id="residentResponsiblePost"
                    type="text"
                    value={editItem.outpost}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root> */}
                  {idx === 0 ? null : (
                    <>
                      {/* <Select
                    onchange={handleAddressChange(idx)}
                    name={'id_responsible_base'}
                    label={{
                      title: 'Base responsável',
                      htmlFor: '',
                      color: '',
                      fontSize: '14px',
                    }}
                    data={baseOptions || []}
                    backgroundcolor=""
                    bordercolor=""
                    currentOption={item.id_responsible_base}
                    outlinecolor=""
                  /> */}
                      {/* <Input.Root>
                    <Input.Label
                      title="Base responsável"
                      htmlFor={'residentResponsableBase' + idx}
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id={'residentResponsableBase' + idx}
                        name="base"
                        onChange={handleAddressChange(idx)}
                        type="text"
                        required
                      />
                    </Input.Wrapper>
                  </Input.Root> */}
                      {/* <Input.Root>
                    <Input.Label
                      title="Posto responsável"
                      htmlFor={'residentResponsiblePost' + idx}
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id={'residentResponsiblePost' + idx}
                        type="text"
                        name="outpost"
                        onChange={handleAddressChange(idx)}
                        required
                      />
                    </Input.Wrapper>
                  </Input.Root> */}
                    </>
                  )}
                </AddressContainer>
              )
            })
          : null}
      </Section>
      <Divider />
      <Section>
        <Title>Veículos da residência</Title>
        {editItem?.Vehicle.length > 0
          ? editItem?.Vehicle.map((item, idx) => {
              return (
                <AddressContainer key={'Vehicle' + idx}>
                  <TitleLine title={'Veículo ' + (idx + 1)} />
                  <Select
                    flex="1"
                    onchange={() => console.log('')}
                    disabled
                    name={'type'}
                    label={{
                      title: 'Tipo do veículo',
                      htmlFor: '',
                      color: '',
                      fontSize: '12px',
                    }}
                    data={[
                      { id: 'CARRO', value: 'Carro' },
                      { id: 'MOTO', value: 'Moto' },
                    ]}
                    backgroundcolor=""
                    bordercolor="#CECECE"
                    currentOption={item.type}
                    outlinecolor=""
                  />
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Veículo do usuário:"
                        htmlFor={'residentVehicleUser' + idx}
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id={'residentVehicleUser' + idx}
                          type="text"
                          value={item.vehicle}
                          name="vehicle"
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Cor do carro:"
                        htmlFor={'residentVehicleColor' + idx}
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id={'residentVehicleColor' + idx}
                          type="text"
                          name="color"
                          value={item.color}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Placa:"
                        htmlFor={'residentVehiclePlate' + idx}
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id={'residentVehiclePlate' + idx}
                          type="text"
                          name="plate"
                          value={item.plate}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                </AddressContainer>
              )
            })
          : null}
      </Section>
      <Divider />
      <Section>
        <Title>Informações de acesso</Title>
        <TitleLine title={'Acesso usuário principal'} />
        <Input.Root>
          <Input.Label title="Usuário - login" htmlFor="residentUserLogin" />
          <Input.Wrapper>
            <Input.Content
              id="residentUserLogin"
              type="text"
              value={editItem.login}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        {/* <Input.Root>
          <Input.Label title="Senha de acesso" htmlFor="residentPassword" />
          <Input.Wrapper>
            <Input.Content
              id="residentPassword"
              type={isPasswordShowing ? 'text' : 'password'}
              value={editItem.password}
              readOnly
              // onChange={(e) => setPassword(e.target.value)}
            />
            <Input.Icon onClick={() => toggleFunction(setIsPasswordShowing)}>
              {isPasswordShowing ? (
                <Eye size={14} color="#494949" />
              ) : (
                <EyeSlash size={14} color="#494949" />
              )}
            </Input.Icon>
          </Input.Wrapper>
        </Input.Root> */}
        {editItem.LinkedUsers.length > 0 ? (
          <>
            <TitleLine title="Usuários cadastrados na residência" />
            {editItem.LinkedUsers?.map((item, idx) => {
              return (
                <Input.Root key={item.id}>
                  <Input.Label
                    title="Usuário - login"
                    htmlFor={'residentUserLogin' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentUserLogin' + idx}
                      type="text"
                      value={item.login}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
              )
            })}
          </>
        ) : null}
        <ButtonRow>
          <ButtonContainer>
            <Button.Root backgroundColor="#003E5F" type="submit">
              <Button.Content title="Ativar usuários" />
            </Button.Root>
          </ButtonContainer>
        </ButtonRow>
      </Section>
    </Container>
  )
}
